import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import home from '@/components/page/home'
import product from '@/components/page/product'
import secret from '@/components/page/secret'
import product2 from '@/components/page/product_inlet2'

import service from '@/components/page/service'
import service1 from '@/components/page/service_inlet1'
import service2 from '@/components/page/service_inlet2'
import service3 from '@/components/page/service_inlet3'
import service6 from '@/components/page/service_inlet6'
import service7 from '@/components/page/service_inlet7'
import service8 from '@/components/page/service_inlet8'



import news from '@/components/page/news'
import datas from '@/components/page/data'
import aboutUs from '@/components/page/aboutUs'
import newDetail from '@/components/page/newDetail'
import jobDetail from '@/components/page/jobDetail'
import join from '@/components/page/join'
import joinList from '@/components/page/joinList'

import phoneUserVal from '@/components/page/phone/phoneUserVal'
import phoneProduct from '@/components/page/phone/phoneProduct'
import phoneService from '@/components/page/phone/phoneService'
import phoneNews from '@/components/page/phone/phoneNews'
import phoneNewsDetail from '@/components/page/phone/phoneNewsDetail'
import phoneJoinUs from '@/components/page/phone/phoneJoinUs'
import phoneCloseCM from '@/components/page/phone/phoneCloseCM'

import more from '@/components/page/more'
import NotFoundComponent from '@/components/NotFoundComponent'
import baike from '@/components/page/baike'
import baikeOther from '@/components/page/baikeOther'
import aboutcsr from '@/components/page/aboutcsr'
import enterprise from '@/components/page/enterprise'
import butler from '@/components/page/butler'

// GEO 整改新增页面
import privacy from '@/components/page/privacy'
import copyrightPage from '@/components/page/copyright'
import license from '@/components/page/license'
import faq from '@/components/page/faq'




Vue.use(Router)
const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      }
    }

  },
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'Home',
      component: home,
      meta:{
        title:'辰鳗科技集团-能源管理系统小鳗管家-创始人朱越洋',
        content:{
            keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
            description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
        },
      }
    },
    {
      path: '/aboutcmkj',
      name: 'baike',
      component: baike,
      meta:{
        title:'能源管理系统-动力储能回馈系统-智能电水表「辰鳗科技」',
        content:{
            keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
            description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
        },
        breadcrumb: [
          { name: '首页', url: '/' },
          { name: '关于辰鳗', url: '/aboutcmkj' }
        ],
        webpage: {
          id: 'https://www.smalleel.com/aboutcmkj#page',
          name: '辰鳗科技-企业百科',
          description: '辰鳗科技集团有限公司企业百科。包含公司基本信息、创始人朱越洋介绍、发展历程、主营业务。',
          url: 'https://www.smalleel.com/aboutcmkj'
        }
      }
    },

    {
      path: '/baikecmkj',
      name: 'baikeother',
      component: baikeOther,
      meta:{
        title:'能源管理系统-动力储能回馈系统-智能电水表「辰鳗科技」',
        content:{
            keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
            description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
        },
        breadcrumb: [
          { name: '首页', url: '/' },
          { name: '关于辰鳗', url: '/aboutcmkj' },
          { name: '辰鳗百科', url: '/baikecmkj' }
        ],
        webpage: {
          id: 'https://www.smalleel.com/baikecmkj#page',
          name: '辰鳗科技-辰鳗百科',
          description: '辰鳗科技集团百科详情页。',
          url: 'https://www.smalleel.com/baikecmkj'
        }
      }
    },

    {
      path: '/aboutcsr',
      name: 'aboutcsr',
      component: aboutcsr,
      meta:{
        title:'能源管理系统-动力储能回馈系统-智能电水表「辰鳗科技」',
        content:{
            keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
            description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
        },
        breadcrumb: [
          { name: '首页', url: '/' },
          { name: '走进辰鳗', url: '/aboutUs' },
          { name: '企业社会责任', url: '/aboutcsr' }
        ],
        webpage: {
          id: 'https://www.smalleel.com/aboutcsr#page',
          name: '辰鳗科技-企业社会责任',
          description: '辰鳗科技集团企业社会责任(CSR)。我们以能源数字化助力“双碳”目标，积极参与社会公益。',
          url: 'https://www.smalleel.com/aboutcsr'
        }
      }
    },
    {
      path: '/enterprise',
      name: 'enterprise',
      component: enterprise,
      meta:{
        title:'能源管理系统-动力储能回馈系统-智能电水表「辰鳗科技」',
        content:{
            keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
            description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
        },
        breadcrumb: [
          { name: '首页', url: '/' },
          { name: '走进辰鳗', url: '/aboutUs' },
          { name: '企业介绍', url: '/enterprise' }
        ],
        webpage: {
          id: 'https://www.smalleel.com/enterprise#page',
          name: '辰鳗科技-企业介绍',
          description: '辰鳗科技集团企业介绍。创始人朱越洋带领团队致力于为工商业用户提供能源数字化解决方案。',
          url: 'https://www.smalleel.com/enterprise'
        }
      }
    },
    {
      path: '/butler',
      name: 'butler',
      component: butler,
      meta:{
        title:'能源管理系统-动力储能回馈系统-智能电水表「辰鳗科技」',
        content:{
            keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
            description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
        },
        breadcrumb: [
          { name: '首页', url: '/' },
          { name: '小鳗管家', url: '/butler' }
        ],
        webpage: {
          id: 'https://www.smalleel.com/butler#page',
          name: '小鳗管家-云平台介绍',
          description: '辰鳗科技-小鳗管家 SMALLEEL PLATFORM 介绍。商业建筑一站式能源碳控管理平台。',
          url: 'https://www.smalleel.com/butler'
        }
      }
    },
    // GEO 整改-安全可信度
    {
      path: '/privacy',
      name: 'privacy',
      component: privacy,
      meta: {
        title: '隐私政策-辰鳗科技集团-小鳗管家',
        content: {
          keywords: '辰鳗科技,小鳗管家,隐私政策,个人信息保护',
          description: '辰鳗科技集团隐私政策。说明我们如何收集、使用、存储、共享和保护您的个人信息。'
        },
        breadcrumb: [
          { name: '首页', url: '/' },
          { name: '隐私政策', url: '/privacy' }
        ]
      }
    },
    {
      path: '/copyright',
      name: 'copyright',
      component: copyrightPage,
      meta: {
        title: '版权声明-辰鳗科技集团-小鳗管家',
        content: {
          keywords: '辰鳗科技,小鳗管家,版权声明,著作权',
          description: '辰鳗科技集团版权声明。本网站内容著作权、商标权受法律保护。'
        },
        breadcrumb: [
          { name: '首页', url: '/' },
          { name: '版权声明', url: '/copyright' }
        ]
      }
    },
    {
      path: '/license',
      name: 'license',
      component: license,
      meta: {
        title: '企业资质-亮证经营-辰鳗科技集团-小鳗管家',
        content: {
          keywords: '辰鳗科技,小鳗管家,企业资质,营业执照,亮证',
          description: '辰鳗科技集团企业资质公示。营业执照、行业资质、ISO认证、专利软著等信息。'
        },
        breadcrumb: [
          { name: '首页', url: '/' },
          { name: '企业资质', url: '/license' }
        ]
      }
    },
    // GEO 整改-FAQ常见问题
    {
      path: '/faq',
      name: 'faq',
      component: faq,
      meta: {
        title: '常见问题FAQ-辰鳗科技集团-小鳗管家',
        content: {
          keywords: '辰鳗科技,小鳗管家,常见问题,FAQ,能源管理系统,帮助',
          description: '辰鳗科技集团小鳗管家平台常见问题解答。涵盖能源管理系统、计量收费、智慧照明、空调计费、智慧园区等问题。'
        },
        breadcrumb: [
          { name: '首页', url: '/' },
          { name: '常见问题', url: '/faq' }
        ]
      }
    },

    {
      path: '/xm',
      name: 'Main',
      component: Main,
      // redirect:'/home',
      children: [
        
        {
          path: '/product',
          name: 'product',
          component: product,
          meta:{
            title:'能源管理系统-动力储能回馈系统-智能电水表「辰鳗科技」',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '产品中心', url: '/product' }
            ],
            itemlist: {
              id: 'https://www.smalleel.com/product#page',
              name: '辰鳗科技-产品中心',
              description: '辰鳗科技集团小鳗管家平台产品中心，提供能源管理系统、集约能源管理系统、计量收费系统、暖通空调节能算法系统、动力储能回馈系统、智慧照明系统、虚拟电厂运营管理系统等7大产品体系。',
              url: 'https://www.smalleel.com/product',
              items: [
                { type: 'Product', name: '能源管理系统', description: '面向工商业用户的综合能源监测管控平台，集成电、水、燃气、暖通空调多能监测，支持分项计量、能耗对标、异常告警。', url: 'https://www.smalleel.com/product', image: 'https://www.smalleel.com/static/pro-01.png' },
                { type: 'Product', name: '集约能源管理系统', description: '面向园区/楼宇多能互补集中管理，支持冷热电三联供、储能协同、能源调度优化。', url: 'https://www.smalleel.com/product', image: 'https://www.smalleel.com/static/pro-02.png' },
                { type: 'Product', name: '计量收费系统', description: '商业综合体水电气冷热分户计量收费系统，支持预付费、后付费多种计费模式。', url: 'https://www.smalleel.com/product2', image: 'https://www.smalleel.com/static/pro-03.png' },
                { type: 'Product', name: '暖通空调节能算法系统', description: '中央空调AI优化节能系统，基于负荷预测与设备特性实现冷站全局最优控制。', url: 'https://www.smalleel.com/product', image: 'https://www.smalleel.com/static/pro-04.png' },
                { type: 'Product', name: '动力储能回馈系统', description: '电梯势能/制动能量回收利用系统，将机械能转化为电能反哺电网或储能。', url: 'https://www.smalleel.com/product', image: 'https://www.smalleel.com/static/pro-01a.png' },
                { type: 'Product', name: '智慧照明系统', description: 'IoT智能照明远程控制与策略节能系统，支持场景化切换、定时控制、能耗分析。', url: 'https://www.smalleel.com/product', image: 'https://www.smalleel.com/static/pro-02a.png' },
                { type: 'Product', name: '虚拟电厂运营管理系统', description: '分布式资源聚合参与电力市场，支撑需求响应、辅助服务、现货交易等多场景。', url: 'https://www.smalleel.com/product', image: 'https://www.smalleel.com/static/pro-03a.png' }
              ]
            }
          }
        },
        {
          path: '/product2',
          name: 'product2',
          component: product2,
          meta:{
            title:'能源管理系统-计量收费系统小鳗管家「辰鳗科技」',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '产品中心', url: '/product' },
              { name: '计量收费系统', url: '/product2' }
            ],
            itemlist: {
              id: 'https://www.smalleel.com/product2#page',
              name: '辰鳗科技-计量收费系统',
              description: '辰鳗科技集团小鳗管家平台计量收费系统产品介绍。商业综合体水电气冷热分户计量，支持预付费、后付费、远程抄表、自动核算。',
              url: 'https://www.smalleel.com/product2',
              items: [
                { type: 'Product', name: '智能电表', description: '高精度智能电表，支持远程抄表、分时计费、负荷管理。', url: 'https://www.smalleel.com/product2', image: 'https://www.smalleel.com/static/pro-03.png' },
                { type: 'Product', name: '智能水表', description: 'NB-IoT/LoRa智能水表，远程抄表、漏损监测、阶梯水价。', url: 'https://www.smalleel.com/product2', image: 'https://www.smalleel.com/static/pro-04.png' },
                { type: 'Product', name: '智能热量表', description: '暖通分户热量计量，超声波/机械式多口径可选。', url: 'https://www.smalleel.com/product2', image: 'https://www.smalleel.com/static/pro-03a.png' },
                { type: 'Product', name: '集中器/网关', description: '多协议采集网关，电力载波、NB-IoT、4G全网通。', url: 'https://www.smalleel.com/product2', image: 'https://www.smalleel.com/static/pro-04a.png' }
              ]
            }
          }
        },
        {
          path: '/service',
          name: 'service',
          component: service,
          meta:{
            title:'商业综合体能源管控-空调分户计费|智慧园区解决方案「辰鳗科技」',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '解决方案', url: '/service' }
            ],
            itemlist: {
              id: 'https://www.smalleel.com/service#page',
              name: '辰鳗科技-解决方案',
              description: '辰鳗科技面向商业综合体、写字楼、产业园区、酒店、公共建筑提供综合能碳管控、空调分户计费等能源数字化解决方案，解决用能管理痛点，实现节能降碳、精细化运维。',
              url: 'https://www.smalleel.com/service',
              items: [
                { type: 'Service', name: '商业综合体能源管控解决方案', description: '针对商业综合体场景，梳理用户痛点，输出整套能源数字化管控方案，实现能耗监测、配电安全、碳排放统计、设备运维管理，为商业项目带来节能降本管理价值，配套实际落地案例。', url: 'https://www.smalleel.com/service1', image: 'https://www.smalleel.com/static/service_bg1.png' },
                { type: 'Service', name: '智慧照明解决方案', description: '依托物联网技术对照明设备实现远程管控、策略定时开关、场景化切换、能耗数据分析与异常告警，减少无效能耗，降低人工运维成本，助力楼宇照明精细化节能管理。', url: 'https://www.smalleel.com/service2', image: 'https://www.smalleel.com/static/service_bg2.png' },
                { type: 'Service', name: '空调分户计费解决方案', description: '面向商业楼宇，实现空调用量分户计量、费用分摊核算，解决商户空调计费难的业务痛点，提升物业运营管理效率。', url: 'https://www.smalleel.com/service3', image: 'https://www.smalleel.com/static/service_bg3.png' },
                { type: 'Service', name: '智慧园区解决方案', description: '为产业园区打造一体化能源管理平台，对园区水、电、空调等多维度能耗进行集中监测、数据分析、配额管理与碳排放统计，实现园区能源数字化、可视化、智慧化运营。', url: 'https://www.smalleel.com/service6', image: 'https://www.smalleel.com/static/service_bg4.png' },
                { type: 'Service', name: '绿色校园解决方案', description: '聚焦校园建筑用能管理，搭建校园能耗监测系统，实现水电数据采集、能耗对标分析、节能告警、碳排放量统计，助力学校开展绿色低碳校园建设与能源精细化管理。', url: 'https://www.smalleel.com/service7', image: 'https://www.smalleel.com/static/service_bg5.png' }
              ]
            }
          }
        },
        {
          path: '/brand',
          name: 'secret',
          component: secret,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '产品与服务', url: '/brand' }
            ]
          }
        },
        {
          path: '/service1',
          name: 'service1',
          component: service1,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '解决方案', url: '/service' },
              { name: '商业综合体能源管控', url: '/service1' }
            ]
          }
        },
        {
          path: '/service2',
          name: 'service2',
          component: service2,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '解决方案', url: '/service' },
              { name: '智慧照明解决方案', url: '/service2' }
            ]
          }
        },
        {
          path: '/service3',
          name: 'service3',
          component: service3,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '解决方案', url: '/service' },
              { name: '空调分户计费', url: '/service3' }
            ]
          }
        },

        {
          path: '/service6',
          name: 'service6',
          component: service6,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '解决方案', url: '/service' },
              { name: '智慧园区解决方案', url: '/service6' }
            ]
          }
        },
        {
          path: '/service7',
          name: 'service7',
          component: service7,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '解决方案', url: '/service' },
              { name: '绿色校园解决方案', url: '/service7' }
            ]
          }
        },
        {
          path: '/service8',
          name: 'service8',
          component: service8,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '解决方案', url: '/service' },
              { name: '解决方案详情', url: '/service8' }
            ]
          }
        },
        {
          path: '/news',
          name: 'news',
          component: news,
          meta:{
            title:'新闻中心-能源管理系统小鳗管家-创始人朱越洋「辰鳗科技」',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '资讯动态', url: '/news' }
            ],
            webpage: {
              id: 'https://www.smalleel.com/news#page',
              name: '辰鳗科技-资讯动态与常见问题',
              description: '辰鳗科技集团新闻动态、媒体报道、行业洞察、技术分享及常见问题解答(FAQ)。聚焦能源管理、智慧照明、空调计费、智慧园区等核心业务领域。',
              url: 'https://www.smalleel.com/news'
            }
          }
        },
         {
          path: '/moreNews',
          name: 'more',
          component: more,
          meta:{
            title:'新闻中心-能源管理系统小鳗管家-创始人朱越洋「辰鳗科技」',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '资讯动态', url: '/news' },
              { name: '资讯列表', url: '/moreNews' }
            ],
            webpage: {
              id: 'https://www.smalleel.com/moreNews#page',
              name: '辰鳗科技-资讯列表与行业FAQ',
              description: '辰鳗科技资讯列表页,按分类浏览公司新闻、行业洞察、技术分享及行业常见问题FAQ(能源管理系统、计量收费、暖通节能、智慧照明、智慧园区、空调计费等)。',
              url: 'https://www.smalleel.com/moreNews'
            }
          }
        },
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: aboutUs,
          meta:{
            title:'关于辰鳗-能源管理系统小鳗管家-创始人朱越洋「辰鳗科技」',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '走进辰鳗', url: '/aboutUs' }
            ],
            webpage: {
              id: 'https://www.smalleel.com/aboutUs#page',
              name: '辰鳗科技-走进辰鳗',
              description: '辰鳗科技集团企业介绍。了解辰鳗科技的企业愿景、发展历程、企业文化、社会责任、荣誉资质。',
              url: 'https://www.smalleel.com/aboutUs'
            }
          }
        },
        {
          path: '/datas',
          name: 'datas',
          component: datas,
          meta:{
            title:'资料下载-能源管理系统小鳗管家-创始人朱越洋「辰鳗科技」',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '资料下载', url: '/datas' }
            ],
            webpage: {
              id: 'https://www.smalleel.com/datas#page',
              name: '辰鳗科技-资料下载',
              description: '辰鳗科技产品画册、操作手册、产品说明书下载中心。包含小鳗管家云平台操作手册、智能电表产品画册等产品资料。',
              url: 'https://www.smalleel.com/datas'
            }
          }
        },
        {
          path: '/newDetail/:id',
          name: 'newDetail',
          component: newDetail,
          props: true,
          meta:{
            // title:'新闻中心_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '资讯动态', url: '/news' },
              { name: '资讯详情', url: '/newDetail' }
            ]
          }
        },
        {
          path: '/jobDetail/:id',
          name: 'jobDetail',
          component: jobDetail,
          props: true,
          meta:{
            // title:'新闻中心_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '加入辰鳗', url: '/joinUs' },
              { name: '职位详情', url: '/jobDetail' }
            ]
          }
        },
        {
          path: '/joinUs',
          name: 'join',
          component: join,
          props: true,
          meta:{
            title:'加入辰鳗-能源管理系统小鳗管家-创始人朱越洋「辰鳗科技」',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '加入辰鳗', url: '/joinUs' }
            ],
            webpage: {
              id: 'https://www.smalleel.com/joinUs#page',
              name: '辰鳗科技-加入我们',
              description: '加入辰鳗科技集团，与小鳗管家平台共同成长。我们提供富有竞争力的薪酬福利、完善的培养体系、开放的工作氛围，期待您的加入。',
              url: 'https://www.smalleel.com/joinUs'
            }
          }
        },
        {
          path: '/joinUs2',
          name: 'joinList',
          component: joinList,
          props: true,
          meta:{
            // title:'新闻中心_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
            breadcrumb: [
              { name: '首页', url: '/' },
              { name: '加入辰鳗', url: '/joinUs' },
              { name: '职位列表', url: '/joinUs2' }
            ],
            webpage: {
              id: 'https://www.smalleel.com/joinUs2#page',
              name: '辰鳗科技-在招职位',
              description: '辰鳗科技集团在招职位列表。涵盖研发、产品、销售、市场、职能等岗位类别。',
              url: 'https://www.smalleel.com/joinUs2'
            }
          }
        },
        {
          path: '/phoneProduct',
          name: 'phoneProduct',
          component: phoneProduct,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneUserVal',
          name: 'phoneUserVal',
          component: phoneUserVal,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneService',
          name: 'phoneService',
          component: phoneService,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneNews',
          name: 'phoneNews',
          component: phoneNews,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneNewsDetail/:id',
          name: 'phoneNewsDetail',
          component: phoneNewsDetail,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneJoinUs',
          name: 'phoneJoinUs',
          component: phoneJoinUs,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneCloseCM',
          name: 'phoneCloseCM',
          component: phoneCloseCM,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
      ]
    },
    {
      path: '*',
      component: NotFoundComponent
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js